import React from "react";

const DARK_ORANGE = "#e85e20";

export const Chevron = ({ color }: { color?: string }) => {
  const adjustedColor = !color ? DARK_ORANGE : color;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill={adjustedColor}
    >
      <path
        fillRule="evenodd"
        d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
